import { JSX, useState } from "react";
import { useToggleableDialog } from "@shared/common/hooks/useToggleableDialog";
import { ToggleableDialog } from "@shared/dialogs/ToggleableDialog";
import { InstanceListWrapper } from "../InstanceDialog/InstanceListWrapper";
import { PlanOverview } from "./PlanOverview";

interface PlanOverviewDialogProps {
  readonly buttonStyle: "secondary" | "tertiary";
}

export function PlanDialog({ buttonStyle }: PlanOverviewDialogProps): JSX.Element {
  const { dialogRef, isOpen, handleCloseDialog } = useToggleableDialog();
  const [dialogState, setDialogState] = useState<"OPEN" | "IMPORT">("OPEN");

  return (
    <ToggleableDialog dialogRef={dialogRef} size={dialogState === "OPEN" ? "l" : "m"}>
      <tractie-button level={buttonStyle} slot="invoker">
        Plannen
      </tractie-button>
      {dialogState === "OPEN" && (
        <PlanOverview
          loadData={isOpen}
          onCloseDialog={handleCloseDialog}
          onOpenImport={() => setDialogState("IMPORT")}
        />
      )}
      {dialogState === "IMPORT" && (
        <InstanceListWrapper onBack={() => setDialogState("OPEN")} onClose={handleCloseDialog} />
      )}
    </ToggleableDialog>
  );
}
